import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import useAuthStore from '../store/authStore';
import { useAuth } from '../hooks/useAuth';
import AppLoader from './AppLoader';

interface AuthStore {
   isAuthenticated: boolean;
   user?: { role?: string } | null;
}

const AdminRoute = () => {
   const { isAuthenticated, user } = useAuthStore() as AuthStore;
   const { isLoading } = useAuth();

   if (isLoading) {
      return <AppLoader />;
   }

   if (!isAuthenticated) {
      return <Navigate to="/" replace />;
   }

   // Admins and staff may enter the admin panel. Which tabs a staff member
   // actually sees is enforced inside the panel (and on the server per tab).
   if (user?.role !== 'admin' && user?.role !== 'staff') {
      return <Navigate to="/home" replace />;
   }

   return <Outlet />;
};

export default AdminRoute;
